import { atom } from 'jotai';

export const drawerOpenAtom = atom(false);
export const drawerExpandedAtom = atom(true);
